import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/client.ts

var client_exports = {};

__export(client_exports, {
  agreeTermsOfService: function agreeTermsOfService() {
    return _agreeTermsOfService;
  },
  bindBbIdentity: function bindBbIdentity() {
    return _bindBbIdentity;
  },
  changeMobilePassword: function changeMobilePassword() {
    return _changeMobilePassword;
  },
  changePassword: function changePassword() {
    return _changePassword;
  },
  createCareRelation: function createCareRelation() {
    return _createCareRelation;
  },
  getChatRooms: function getChatRooms() {
    return _getChatRooms;
  },
  getClient: function getClient() {
    return _getClient;
  },
  getInfoFromId: function getInfoFromId() {
    return _getInfoFromId;
  },
  getMe: function getMe() {
    return _getMe;
  },
  getUnreadCount: function getUnreadCount() {
    return _getUnreadCount;
  },
  updateClient: function updateClient() {
    return _updateClient;
  },
  updateMe: function updateMe() {
    return _updateMe;
  },
  uploadDeviceInfo: function uploadDeviceInfo() {
    return _uploadDeviceInfo;
  }
});

var _getMe = function _getMe(data) {
  return fetcher_default.get("/v4/clients/me", data);
};

var _getClient = function _getClient(id) {
  return fetcher_default.get("/v4/clients/".concat(id));
};

var _updateMe = function _updateMe(data) {
  return fetcher_default.put("/v4/clients/me", data);
};

var _updateClient = function _updateClient(payload) {
  return fetcher_default.put("/v4/clients/".concat(payload.id), payload);
};

var _getUnreadCount = function _getUnreadCount() {
  return fetcher_default.get("/v4/clients/me/unread_count");
};

var _uploadDeviceInfo = function _uploadDeviceInfo(payload) {
  return fetcher_default.post("/v4/clients/me/update_device", payload);
};

var _getChatRooms = function _getChatRooms() {
  return fetcher_default.get("/v4/clients/me/chatrooms");
};

var _changePassword = function _changePassword(payload) {
  return fetcher_default.post("/v4/clients/me/change_password", payload);
};

var _changeMobilePassword = function _changeMobilePassword(payload) {
  return fetcher_default.post("/v4/clients/me/change_mobile_password", payload);
};

var _getInfoFromId = function _getInfoFromId(payload) {
  return fetcher_default.get("/v4/clients/get_info_from_id_or_identity_number", payload);
};

var _createCareRelation = function _createCareRelation(payload) {
  return fetcher_default.post("/v4/care_relations", payload);
};

var _agreeTermsOfService = function _agreeTermsOfService() {
  return fetcher_default.post("/v4/clients/agree_terms_of_service");
};

var _bindBbIdentity = function _bindBbIdentity(payload) {
  return fetcher_default.post("/v4.1/clients/bot_bonnie_identities", payload);
};

export { _getMe as getMe, _getClient as getClient, _updateMe as updateMe, _updateClient as updateClient, _getUnreadCount as getUnreadCount, _uploadDeviceInfo as uploadDeviceInfo, _getChatRooms as getChatRooms, _changePassword as changePassword, _changeMobilePassword as changeMobilePassword, _getInfoFromId as getInfoFromId, _createCareRelation as createCareRelation, _agreeTermsOfService as agreeTermsOfService, _bindBbIdentity as bindBbIdentity, client_exports };